// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);

  setTimeout(updateCartQuantities, 500);
  setTimeout(updateCartItemPrice, 500);
  setTimeout(formatCartPrices, 2000);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

// Function to detect cart item and update price
function updateCartItemPrice() {
  // Find the cart item with the specific data-id
  const cartItem = document.querySelector('[data-id="52408941510996"]');
  
  if (cartItem) {
    // Find the quantity input within this cart item
    const quantityInput = cartItem.querySelector('.quantity-input input[type="number"]');
    const priceElement = cartItem.querySelector('.quick-cart__item-price');
    
    if (quantityInput && priceElement) {
      // Get the current quantity
      const quantity = parseInt(quantityInput.value) || 0;
      
      // Calculate new price (€0,01 × quantity)
      const basePrice = 0.01;
      const newPrice = (basePrice * quantity).toFixed(2);
      
      // Update the price display
      priceElement.textContent = `€${newPrice.replace('.', ',')} EUR`;
      
      // Hide the quantity input element
      const quantityInputContainer = cartItem.querySelector('.quantity-input');
      if (quantityInputContainer) {
        quantityInputContainer.style.display = 'none';
      }

       // Update cart quantities with corrected calculation
       updateCartQuantities();
     }
   } else {
     console.log('Cart item with data-id="52408941510996" not found');
   }
 }

// Function to calculate and update cart quantities
function updateCartQuantities() {
  // Find all cart items
  const allCartItems = document.querySelectorAll('.quick-cart__item');
  let totalQuantity = 0;
  
  // Calculate total quantity for all cart items
  allCartItems.forEach(item => {
    const quantityInput = item.querySelector('.quantity-input__input');
    const isSpecialItem = item.getAttribute('data-id') === '52408941510996';
    
    if (quantityInput) {
      if (isSpecialItem) {
        // Special item: count as 1 instead of inflated quantity
        totalQuantity += 1;
      } else {
        // Regular item: use actual quantity
        const quantity = parseInt(quantityInput.value) || 0;
        totalQuantity += quantity;
      }
    }
  });
  
  // Update cart quantity displays
  const cartCountElements = document.querySelectorAll('[data-js-cart-count]');
  const cartHeadingElements = document.querySelectorAll('.quick-cart__heading sup');
  const cartFormItemCountElements = document.querySelectorAll('.cart__form-item-count');
  
  // Update shopping bag count
  cartCountElements.forEach(element => {
    element.textContent = totalQuantity.toString();
  });
  
  // Update cart heading superscript
  cartHeadingElements.forEach(element => {
    element.textContent = totalQuantity.toString();
  });

  // Update cart form item count
  cartFormItemCountElements.forEach(element => {
    // Update the text to show the corrected quantity
    element.textContent = `${totalQuantity} tuotetta`;
  });
}

// Run the function when the DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateCartItemPrice);
} else {
  updateCartItemPrice();
}

// Also run the function after a short delay to ensure all elements are properly loaded
setTimeout(updateCartItemPrice, 500);

// Function to format cart prices with proper comma separators
function formatCartPrices() {
  // Find all cart price wrapper elements
  const priceElements = document.querySelectorAll('.cart__form-item-price-wrapper');
  
  priceElements.forEach(priceElement => {
    // Get the current price text
    let priceText = priceElement.textContent.trim();
    
    // Check if it contains a price (starts with €)
    if (priceText.startsWith('€')) {
      // Extract the number part (remove € and any whitespace)
      const numberPart = priceText.replace('€', '').trim();
      
      // Check if it's a valid number
      if (!isNaN(numberPart) && numberPart !== '') {
        // Convert to number and treat as cents (divide by 100)
        const number = parseInt(numberPart);
        const euros = number / 100;
        
        // Format with Finnish locale (comma as decimal separator)
        // For €21600, this will become €216,00
        const formattedNumber = euros.toLocaleString('fi-FI', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        
        // Update the price element with formatted price
        priceElement.textContent = `€${formattedNumber} EUR`;
        
        console.log(`Formatted price: ${priceText} → €${formattedNumber}`);
      }
    }
  });
}

// Run the function when the DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', formatCartPrices);
} else {
  formatCartPrices();
}

// Also run the function after a short delay to ensure all elements are properly loaded
setTimeout(formatCartPrices, 2000);

// Keep the collection filter bar filters panel closed on load and after AJAX updates.
// The theme renders it open when active filters exist (e.g. pagination with filters applied).
function closeFilterBarFilters() {
  document.querySelectorAll("[data-filter-bar-filters]").forEach(function (filterBarFilters) {
    filterBarFilters.setAttribute("aria-hidden", "true");
    filterBarFilters.style.display = "none";
  });

  document.querySelectorAll('[data-dropdown-toggle="filter-bar-filters"]').forEach(function (toggle) {
    toggle.setAttribute("aria-expanded", "false");
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", closeFilterBarFilters);
} else {
  closeFilterBarFilters();
}

document.addEventListener("collection:updated", closeFilterBarFilters);